import type { AnyItem, ResolvedMonospacePrimitiveField } from '#layers/data-model/public';
import type { useCollectionRoutes } from '#layers/spaces/public';
import { isNil } from '#layers/base/public';
import { pickByPrimitiveFields } from '#layers/data-model/public';

/**
 * Resolves an item's detail route from its primary key fields. Returns `undefined` when the
 * collection has no primary key or the item does not carry a complete one.
 */
export function getRelatedItemDetailRoute(
	item: AnyItem,
	primaryKeyFields: ResolvedMonospacePrimitiveField[],
	detailRoute: ReturnType<typeof useCollectionRoutes>['detailRoute'],
) {
	if (primaryKeyFields.length === 0) return;

	const key = pickByPrimitiveFields(item, primaryKeyFields);

	// `pick` drops undefined but keeps null, which would route to a literal "null" segment.
	if (Object.keys(key).length !== primaryKeyFields.length || Object.values(key).some((value) => isNil(value))) return;

	return detailRoute(key);
}
